import React from 'react';
import { Quota } from '../types';
import { useCurrentUserQuotas } from '../hooks';
import Loader from '../../../components/v2/Loader';
import AccountLimitReached from '../../../components/Account/AccountLimitReached';

type Props = {
  quota: Quota;
};

const AccountQuotaGuard = ({
  quota,
  children,
}: React.PropsWithChildren<Props>) => {
  const quotaQuery = useCurrentUserQuotas();

  if (quotaQuery.isLoading) {
    return <Loader />;
  }

  if (!quotaQuery.data?.enabled) {
    return children;
  }

  if (quotaQuery.data?.quotas?.[quota]?.reached) {
    return <AccountLimitReached quota={quota} />;
  }

  return children;
};

export default AccountQuotaGuard;
